/**
 * Since we can get all (most) of the configurations we need from an API
 * endpoint, the goal here is to reduce window.CCMT_SDK down to this, and inject
 * the provider into the config block of things that need subsequent
 * configuration to set the values manually on demand:
 *
 * CCMT_SDK = {
 *     account_id: 'T41NG5',
 *     group_id: 2,
 *     solution_id: 3
 * }
 */
(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.sdk.config'
  var CCMT_ENV = require('./env')

  require('angular')
    .module(MODULE_NAME, [
      require('ng-device-detector'),
      require('./config')
    ])
    .provider('SdkConfig', sdkConfigProvider)
    .run(sdkConfigSetup)

  sdkConfigProvider.$inject = ['$windowProvider', 'ThismomentConfigProvider']
  function sdkConfigProvider ($windowProvider, ThismomentConfigProvider) {
    var $window = $windowProvider.$get()
    var SdkConfig = ThismomentConfigProvider.setupConfig(angular.merge({
      tracking: true
    }, CCMT_ENV, $window.CCMT_SDK))

    return {
      get: SdkConfig.get,
      set: SdkConfig.set,
      $get: sdkConfigService
    }

    function sdkConfigService () {
      SdkConfig.set({
        host_url: $window.location.protocol + '//' + $window.location.host + $window.location.pathname
      })
      return SdkConfig
    }
  }

  sdkConfigSetup.$inject = ['$rootScope', '$window', 'deviceDetector', 'SdkConfig']
  function sdkConfigSetup ($rootScope, $window, deviceDetector, SdkConfig) {
    SdkConfig.set({
      breakpoint: getCurrentBreakpoint(),
      is_mobile: deviceDetector.isMobile()
    })

    angular.element($window).bind('resize', function onResize () {
      screenResizeEvent()
    })

    angular.element($window).bind('orientationchange', function onOrientationchange () {
      screenResizeEvent()
    })

    function getCurrentBreakpoint () {
      var windowWidth = $window.innerWidth
      var breakpoints = {
        xs: [-1, 767],
        sm: [768, 991],
        md: [992, 1199],
        lg: [1200, -1]
      }
      var current

      angular.forEach(breakpoints, function (value, key) {
        if ((windowWidth > value[0] || value[0] < 0) && (windowWidth < value[1] || value[1] < 0)) {
          current = key
        }
      })

      return current
    }

    function screenResizeEvent () {
      var breakpoint = getCurrentBreakpoint()

      if (SdkConfig.get('breakpoint') !== breakpoint) {
        SdkConfig.set('breakpoint', breakpoint)
        $rootScope.$broadcast('breakpoint:resize')
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/sdk-config.js